var defaultAttributes = {
  colors: {
    actionHover: '#79B7E1',
    adminBlue: '#3498DB',
    blue: '#0000FF',
    cobalt: '#266D90',
    darkGrey: '#222222',
    darkGreyOp: 'rgba(34, 34, 34, 0.8)',
    darkSea: '#0F5357',
    defaultGrey: '#CCCCCC',
    eclipseGrey: '#2E2E2E',
    eggplant: '#AD1457',
    errorRed: '#F81628',
    gammaBlue: '#3BBEC9',
    grey: '#444444',
    gradientOne: '#FAD961',
    gradientTwo: '#FA5400',
    gradientThree: '#3498DB',
    gradientFour: '#5300A3',
    laserOrange: '#FCBF42',
    lightGrey: '#DDDDDD',
    marigold: '#FFC107',
    mediumGrey: '#666666',
    mediumLightGrey: '#999999',
    nearBlack: '#111111',
    nearWhite: '#F7F7F7',
    nikeFuel: '#8DDF3D',
    nikeOrange: '#F4562C',
    pinkFoil: '#E03D89',
    raspberryRed: '#6F0D4F',
    red: '#FF0000',
    teal: '#009688',
    transparent: 'rgba(255, 255, 255, 0.0)',
    ultraLightGrey: '#E5E5E5',
    vividBlue: '#2F9CC2',
    volt: '#E7FB4C',
    white: '#FFFFFF'
  },
  fonts: {
    brand: 'Nike TG, Helvetica, sans-serif',
    "default": "Helvetica, 'Helvetica Neue', Roboto, sans-serif",
    mono: 'Menlo, Monaco, Consolas, Courier New, monospace'
  },
  opacities: {
    disabled: 0.6,
    faded: 0.9,
    hide: 0,
    show: 1.0
  },
  transforms: {
    centerHorizontally: 'translateX(-50%)',
    centerVertically: 'translateY(-50%)'
  },
  transitions: {
    dialogButton: 'border 200ms 0ms ease-in-out',
    hover: 'background-color 200ms 0ms linear, color 200ms 0ms linear',
    opacity: 'opacity 250ms 0s ease-in-out'
  }
};
var colors = defaultAttributes.colors;
var defaultGlobals = {
  '*::selection': {
    backgroundColor: colors.adminBlue,
    color: colors.white
  }
};
export { defaultAttributes, defaultGlobals };